export default __webpack_public_path__ + "static/media/SndLowerOMagicC.ffd556f8.mp3";